const css = require('./action-panel.css');
const signals = require('../../../../../signals/account/orders');
const bitrix = require('../../../../../signals/bitrix');
let { cut } = require('../../../../../helpers/utils');
const CONTINUE_BUTTON_SELECTOR = cut(css.continueButton);
const CANCEL_BUTTON_SELECTOR = cut(css.cancelButton);
const PAY_ONLINE_BUTTON_SELECTOR = cut(css.payOnlineButton);
const SAVE_ALL_BUTTON_SELECTOR = cut(css.saveAllButton);
const MAKE_ORDER_BUTTON_SELECTOR = cut(css.makeOrderButton);
const REPEAT_ORDER_BUTTON_SELECTOR = cut(css.repeatOrderButton);

const { Checkbox } = require('../../../../../packages/account-ui');
let PaymentForm = require('./payment-form');
const { onMakeOrderUnauthorized } = require('../../../../../signals/order');
let { redirect } = require('../../../../../signals/utils');
let { raiseEvent } = require('../../../../../signals/analytics');

class ActionPanel {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [CONTINUE_BUTTON_SELECTOR]: this.moveOrderToNextState,
                [PAY_ONLINE_BUTTON_SELECTOR]: this.payOnline,
                [CANCEL_BUTTON_SELECTOR]: this.cancelOrder,
                [SAVE_ALL_BUTTON_SELECTOR]: this.applyLocalChanges,
                [MAKE_ORDER_BUTTON_SELECTOR]: this.makeOrder,
                [REPEAT_ORDER_BUTTON_SELECTOR]: this.repeatOrderButton,
                [cut(css.redirect)]: this.redirect,
                [cut(css.redirectToLeadsMapping)]: this.redirectToLeadsMapping,
                [cut(css.redirectToLeadsMappingFree)]: this.redirectToLeadsMappingFree
            }
        };
    }

    makeOrder () {
        this.$context.signal(onMakeOrderUnauthorized);
    }

    payOnline () {
        this.$context.signal(signals.payOnline);
    }

    moveOrderToNextState () {
        this.$context.signal(signals.tryMoveOrderToNextState);
    }

    cancelOrder () {
        this.$context.signal(signals.archiveOrder);
    }

    applyLocalChanges () {
        this.$context.signal(signals.applyLocalChanges);
    }

    repeatOrderButton () {
        this.$context.signal(signals.repeatOrder);
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }

    redirectToLeadsMapping () {
        this.$context.signal(bitrix.redirectToLeadsMapping);
    }

    redirectToLeadsMappingFree () {
        this.$context.signal(raiseEvent, { category: 'button_bitrix_export_free_page', action: 'click' });
        this.$context.signal(bitrix.redirectToLeadsMapping, { isExportFree: true });
    }
}

module.exports = {
    constructor: ActionPanel,
    children: [
        {
            name: 'license-checkbox',
            component: Checkbox,
            props: {
                signal: signals.licenseAccepted
            },
            watcher: {
                value: ['account', 'orders', 'currentOrder', 'update', 'userAcceptLicenseAgreement']
            }
        },
        {
            name: 'payment-form',
            component: PaymentForm,
            watcher: {
                url: ['account', 'orders', 'currentOrder', 'paymentForm', 'url'],
                data: ['account', 'orders', 'currentOrder', 'paymentForm', 'data']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/action-panel/index.js